module.exports = __webpack_public_path__ + "media/games-16.50399564.mp4";